import React from "react";

function PostTag(props) {

    return (
        <button className={props.className} onClick={props.onClick}>#{props.tag}</button>
    )
}

export default PostTag